
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import BacButton from '@/components/BacButton.vue'
import BacTextarea from '@/components/BacTextarea.vue'

import { Team } from '../../lib/models/Team'

import sanitizeHtml from 'sanitize-html'
import { RallyRound } from '../../lib/models/RallyRound'
import UIkit from 'uikit'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacLoggedInHeader,
    BacModal,
    BacInput,
    BacButton,
    BacTextarea
  }
})
export default class TeamSearch extends Vue {
  search = ''
  searchResults: Team[] = []

  sanitizeHtml = sanitizeHtml

  viewTeamMemberId = -1
  viewTeamMember = {}

  changeTeamId = -1
  changeRallyRoundId = -1
  changeRallyRound: RallyRound = new RallyRound()
  availableRallyRounds = []
  newRallyRoundId = -1

  headers = [
    { text: 'Name', value: 'name', width: 80 },
    { text: 'Startnummer', value: 'startnumber', width: 15 },
    { text: 'Runden', value: 'rounds', width: 100 },
    { text: 'Teilnehmer', value: 'members', width: 30 },
    { text: 'Register ID', value: 'registerId', width: 30 }
  ]

  @Watch('changeRallyRoundId')
  async onChangeRallyRound () {
    this.availableRallyRounds = []

    this.searchResults.forEach(team => {
      team.rounds.forEach(rallyRound => {
        if (rallyRound.id === this.changeRallyRoundId) {
          this.changeRallyRound = rallyRound
        }
      })
    })

    this.availableRallyRounds = await (await Http.request(`/api/rally/${this.changeRallyRound.rallyId}/rounds`)).json()
  }

  @Watch('viewTeamMemberId')
  setViewTeamMember () {
    this.searchResults.forEach(team => {
      team.members.forEach(member => {
        if (member.id === this.viewTeamMemberId) {
          this.viewTeamMember = member
        }
      })
    })
  }

  get items () {
    return this.searchResults.map(team => {
      let registerIds = '-'
      if (team.registrations && team.registrations.length) {
        registerIds = team.registrations
          .map(registration => registration.id)
          .join('<br>')
      }

      return {
        id: team.id || '-',
        name: team.name || '-',
        startnumber: team.number || '-',
        members: team.members,
        rounds: team.rounds,
        registerId: registerIds
      }
    })
  }

  mounted () {
    this.searchTeams()
  }

  private searchTimeout = 0;
  @Watch('search')
  onSearchChanged () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    this.searchTimeout = setTimeout(this.searchTeams, 500)
  }

  async searchTeams () {
    this.searchResults = await Team.search(this.search)
  }

  async updateRallyRound () {
    const teamId = this.changeTeamId
    const oldRallyRoundId = this.changeRallyRoundId
    const newRallyRoundId = this.newRallyRoundId
    const res = await Http.request(`/api/team/${teamId}/update-rally-round/${oldRallyRoundId}/${newRallyRoundId}`, {
      method: 'PUT'
    })
    const resData = await res.json()
    if (resData && resData.success) {
      UIkit.notification({
        message: 'Neue Runde erfolgreich gesetzt!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      this.searchTeams()
    }
  }
}
